import { useField } from '@rocketseat/unform';
import React, { useCallback, useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import {
  Button,
  CanAccess,
  ComboModalidadeTermo,
  Dropdown,
  TextField,
  WrapperFlex,
} from '@unimed-fesp/components';

import {
  CardFilter,
  CardFilterContent,
  CardFilterFooter,
  CardFilterHeader,
} from '../../molecules/CardFilter';
import DatePicker from '../../molecules/DatePicker';
import LabelContainer from '../../molecules/LabelContainer';

import { ComboDatePicker, Container } from './styles';

import { isNumber } from '../../../utils/validation';

import { TipoPerfilUsuarioEnum } from '../../../enums';
import { isContratanteNestle } from '../../../utils/userRole';

function FilterExtends({
  isOpen,
  isGetModalidadesSuccess,
  modalidades,
  handleGetModalidadesByContratante,
  setSearchBoxValue,
  cleanFilterParams,
  showwFilterNomeArquivo = false,
}) {
  const optionsTipo = [
    {
      onClickOption: () => handleSelectedTipo('Lote'),
      text: 'Lote',
    },
    {
      onClickOption: () => handleSelectedTipo('Manual'),
      text: 'Manual',
    },
    {
      onClickOption: () => handleSelectedTipo('Transferência'),
      text: 'Transferência',
    },
  ];

  const optionsMovimentacao = [
    {
      onClickOption: () => handleSelectedMovimentacao('Inclusão'),
      text: 'Inclusão',
    },
    {
      onClickOption: () => handleSelectedMovimentacao('Alteração'),
      text: 'Alteração',
    },
    {
      onClickOption: () => handleSelectedMovimentacao('Exclusão'),
      text: 'Exclusão',
    },
    {
      onClickOption: () => handleSelectedMovimentacao('Transferência'),
      text: 'Transferência',
    },
    {
      onClickOption: () => handleSelectedMovimentacao('Inativos'),
      text: 'Inativos',
    },
  ];

  const optionsVencidas = [
    {
      onClickOption: () => handleSelectedListasVencidas('Todas'),
      text: 'Todas',
    },
    {
      onClickOption: () => handleSelectedListasVencidas('Sim'),
      text: 'Sim',
    },
    {
      onClickOption: () => handleSelectedListasVencidas('Não'),
      text: 'Não',
    },
  ];

  const optionsRN412 = [
    {
      onClickOption: () => handleSelectedRN412('Todas'),
      text: 'Todas',
    },
    {
      onClickOption: () => handleSelectedRN412('Sim'),
      text: 'Sim',
    },
    {
      onClickOption: () => handleSelectedRN412('Não'),
      text: 'Não',
    },
  ];

  const { usuario } = useSelector((state) => state.auth);
  const registerNomeBeneficiarioCartao = useField(
    'nomeBeneficiarioCartao'
  ).registerField;
  const registerContratante = useField('codigoContratante').registerField;
  const registerArquivo = useField('nomeArquivoMovimentacao').registerField;
  const registerTipos = useField('tipo').registerField;
  const registerMovimentacao = useField('movimentacao').registerField;
  const registerModalidades = useField('modalidade').registerField;
  const registerTermos = useField('termo').registerField;
  const registerVencidas = useField('vencida').registerField;
  const registerRN412 = useField('rn412').registerField;

  const [selectedMovimentacao, setSelectedMovimentacao] = useState('');
  const [selectedTipo, setSelectedTipo] = useState('');
  const [selectedModalidade, setSelectedModalidade] = useState('');
  const [selectedTermo, setSelectedTermo] = useState('');
  const [inputContratante, setInputContratante] = useState('');
  const [inputNomeBeneficiarioCartao, setInputNomeBeneficiarioCartao] =
    useState('');
  const [inputNomeArquivoMovimentacao, setInputNomeArquivoMovimentacao] =
    useState('');
  const [selectedListasVencidas, setSelectedListasVencidas] = useState('');
  const [selectedRN412, setSelectedRN412] = useState('');
  const [disableImportarCriacao, setDisableImportarCriacao] = useState(false);
  const [disableImportarAtualizacao, setDisableImportarAtualizacao] =
    useState(false);
  const [dates, setDates] = useState({
    dataCriacaoDe: null,
    dataCriacaoAte: null,
    dataAtualizacaoDe: null,
    dataAtualizacaoAte: null,
  });

  function handleDataCriacaoDe(e) {
    if (e.target) return;
    const dataCriacaoAte = e > dates.dataCriacaoAte ? e : dates.dataCriacaoAte;
    setDates({
      dataCriacaoDe: e,
      dataCriacaoAte,
      dataAtualizacaoDe: dates.dataAtualizacaoDe,
      dataAtualizacaoAte: dates.dataAtualizacaoAte,
    });
  }

  function handleDataCriacaoAte(e) {
    if (e.target) return;
    setDates({
      dataCriacaoDe: dates.dataCriacaoDe,
      dataCriacaoAte: e,
      dataAtualizacaoDe: dates.dataAtualizacaoDe,
      dataAtualizacaoAte: dates.dataAtualizacaoAte,
    });
  }

  function handleDataAtualizacaoDe(e) {
    if (e.target) return;
    const dataAtualizacaoAte =
      e > dates.dataAtualizacaoAte ? e : dates.dataAtualizacaoAte;
    setDates({
      dataCriacaoDe: dates.dataCriacaoDe,
      dataCriacaoAte: dates.dataCriacaoAte,
      dataAtualizacaoDe: e,
      dataAtualizacaoAte,
    });
  }

  function handleDataAtualizacaoAte(e) {
    if (e.target) return;
    setDates({
      dataCriacaoDe: dates.dataCriacaoDe,
      dataCriacaoAte: dates.dataCriacaoAte,
      dataAtualizacaoDe: dates.dataAtualizacaoDe,
      dataAtualizacaoAte: e,
    });
  }

  function handleSelectedMovimentacao(text) {
    setSelectedMovimentacao(text);
  }

  function handleSelectedTipo(texto) {
    setSelectedTipo(texto);
  }

  function handleInputContratanteChange(e) {
    if (e.target.value === '' || isNumber(e.target.value))
      setInputContratante(e.target.value);

    if (e.target.value === '') {
      setSelectedModalidade('');
      setSelectedTermo('');
    }
  }

  function handleLimparFiltros() {
    setSelectedTipo('');
    setSelectedMovimentacao('');
    setSelectedModalidade('');
    setSelectedTermo('');
    setDates({
      dataCriacaoDe: null,
      dataCriacaoAte: null,
      dataAtualizacaoDe: null,
      dataAtualizacaoAte: null,
    });
    setInputContratante('');
    setSearchBoxValue('');
    cleanFilterParams();
    setInputNomeBeneficiarioCartao('');
    setSelectedListasVencidas('');
    setSelectedRN412('');
    setInputNomeArquivoMovimentacao('');
  }

  function handleInputNomeBeneficiarioCartao(e) {
    setInputNomeBeneficiarioCartao(e.target.value);
  }

  function handleInputNomeArquivoMovimentacao({ target }) {
    setInputNomeArquivoMovimentacao(target.value);
  }

  function handleSelectedListasVencidas(text) {
    setSelectedListasVencidas(text);
  }
  function handleSelectedRN412(text) {
    setSelectedRN412(text);
  }

  useEffect(() => {
    function handleDisableImportar() {
      if (
        (dates.dataCriacaoDe && dates.dataCriacaoAte) ||
        (!dates.dataCriacaoDe && !dates.dataCriacaoAte)
      ) {
        setDisableImportarCriacao(false);
      } else {
        setDisableImportarCriacao(true);
      }

      if (
        (dates.dataAtualizacaoDe && dates.dataAtualizacaoAte) ||
        (!dates.dataAtualizacaoDe && !dates.dataAtualizacaoAte)
      ) {
        setDisableImportarAtualizacao(false);
      } else {
        setDisableImportarAtualizacao(true);
      }
    }

    handleDisableImportar();
  }, [dates]);

  const shapeModalidades = useCallback((modalidadesParam) => {
    const modalidadesInativos = [36, 38];

    return modalidadesParam.map(({ codigoModalidade, termos }) =>
      modalidadesInativos.includes(codigoModalidade)
        ? {
            text: codigoModalidade.toString(),
            termos: [],
          }
        : {
            text: codigoModalidade.toString(),
            termos: termos.map((termo) => termo.codigoTermo.toString()),
          }
    );
  }, []);

  return (
    <Container isOpen>
      <CardFilter>
        <CardFilterHeader>filtro avançado</CardFilterHeader>
        <CardFilterContent minHeight="184">
          <WrapperFlex flexWrap justifyStart>
            <TextField
              name="nomeBeneficiarioCartao"
              width={300}
              height={46}
              marginBottom={6}
              marginTop={11}
              labelText="Nome Beneficiário ou Cartão"
              font="13px 'Calibri Regular'"
              typeTextField="text"
              onChange={(e) => {
                handleInputNomeBeneficiarioCartao(e);
              }}
              value={inputNomeBeneficiarioCartao}
              placeholder="Pesquise por nome do beneficiário ou cartão"
              register={registerNomeBeneficiarioCartao}
            />
            <Dropdown
              options={optionsTipo}
              tipo="dropdown"
              width={231}
              labelText="Tipos"
              name="tipo"
              marginTop={11}
              height={46}
              register={registerTipos}
            >
              {selectedTipo || 'Selecione o tipo'}
            </Dropdown>
            <Dropdown
              options={optionsMovimentacao}
              tipo="dropdown"
              width={231}
              labelText="Movimentação"
              name="movimentacao"
              marginTop={11}
              height={46}
              register={registerMovimentacao}
            >
              {selectedMovimentacao || 'Selecione a movimentação'}
            </Dropdown>
            <CanAccess
              checkRole={{
                Adm: TipoPerfilUsuarioEnum.returnNameForName.Adm,
              }}
              userRole={usuario.role}
            >
              <TextField
                name="codigoContratante"
                width={170}
                height={46}
                marginBottom={6}
                marginTop={11}
                labelText="Contratante"
                font="13px 'Calibri Regular'"
                typeTextField="text"
                onChange={(e) => {
                  handleInputContratanteChange(e);
                }}
                onBlur={(e) =>
                  handleGetModalidadesByContratante(e, inputContratante)
                }
                value={inputContratante}
                placeholder="Selecione a contratante"
                register={registerContratante}
              />
            </CanAccess>
            <ComboModalidadeTermo
              setModalidade={setSelectedModalidade}
              modalidade={selectedModalidade}
              termo={selectedTermo}
              setTermo={setSelectedTermo}
              modalidades={
                !inputContratante && !usuario.codigoContratante
                  ? []
                  : shapeModalidades(modalidades)
              }
              registerModalidades={registerModalidades}
              registerTermos={registerTermos}
              contratante={inputContratante}
              margin={11}
            />
            <Dropdown
              options={optionsVencidas}
              tipo="dropdown"
              width={100}
              labelText="Listas Vencidas"
              name="vencida"
              marginTop={11}
              height={46}
              register={registerVencidas}
            >
              {selectedListasVencidas || 'Todas'}
            </Dropdown>
            <Dropdown
              options={optionsRN412}
              tipo="dropdown"
              width={100}
              labelText="RN412"
              name="rn412"
              marginTop={11}
              height={46}
              register={registerRN412}
            >
              {selectedRN412 || 'Todas'}
            </Dropdown>
            {(usuario.role === 'Adm' || isContratanteNestle(usuario)) &&
              showwFilterNomeArquivo && (
                <TextField
                  name="nomeArquivoMovimentacao"
                  width={300}
                  height={46}
                  marginBottom={6}
                  marginTop={11}
                  marginLeft={20}
                  labelText="Nome Arquivo de Movimentação"
                  font="13px 'Calibri Regular'"
                  typeTextField="text"
                  onChange={(e) => {
                    handleInputNomeArquivoMovimentacao(e);
                  }}
                  value={inputNomeArquivoMovimentacao}
                  placeholder="Pesquise por nome arquivo de movimentação"
                  register={registerArquivo}
                />
              )}
          </WrapperFlex>
          <WrapperFlex flexWrap justifyStart>
            <LabelContainer marginBottom="6" text="Data de criação">
              <ComboDatePicker>
                <DatePicker
                  name="dataCriacaoDe"
                  onChange={handleDataCriacaoDe}
                  value={dates.dataCriacaoDe}
                />
                <p>à</p>
                <DatePicker
                  onChange={handleDataCriacaoAte}
                  name="dataCriacaoAte"
                  minDate={dates.dataCriacaoDe}
                  value={dates.dataCriacaoAte}
                />
              </ComboDatePicker>
            </LabelContainer>
            <LabelContainer
              marginBottom="6"
              text="Data de atualização"
              marginLeft="20px"
            >
              <ComboDatePicker>
                <DatePicker
                  name="dataAtualizacaoDe"
                  onChange={handleDataAtualizacaoDe}
                  value={dates.dataAtualizacaoDe}
                />
                <p>à</p>
                <DatePicker
                  onChange={handleDataAtualizacaoAte}
                  name="dataAtualizacaoAte"
                  minDate={dates.dataAtualizacaoDe}
                  value={dates.dataAtualizacaoAte}
                />
              </ComboDatePicker>
            </LabelContainer>
          </WrapperFlex>
        </CardFilterContent>
        <CardFilterFooter justifyContent="left">
          {/* <input type="submit" value="pesquisar" /> */}
          <Button
            tipo="primary"
            paddingTop={8}
            paddingBottom={8}
            paddingLeft={8}
            paddingRight={8}
            justifyCenter
            alignCenter
            type="submit"
            opacity={
              disableImportarCriacao || disableImportarAtualizacao ? 0.4 : 1
            }
            font="16px unimed_slabregular"
            width={100}
          >
            pesquisar
          </Button>
          <Button
            tipo="tertiary"
            paddingTop={8}
            paddingBottom={8}
            paddingLeft={8}
            paddingRight={8}
            justifyCenter
            alignCenter
            type="button"
            onClick={handleLimparFiltros}
            font="16px unimed_slabregular"
            width={100}
          >
            limpar
          </Button>
        </CardFilterFooter>
      </CardFilter>
    </Container>
  );
}

export default FilterExtends;
